<div class="signatory-list-wrapper">
  <app-toolbar />
  <section class="feature-shell">
    <h1>Signatory List</h1>
    <p class="placeholder">Content coming soon.</p>
  </section>
  <app-footer />
</div>
